const AdminClubs = ({ color = "currentColor" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2394_992)">
        <path
          d="M8 14.5C8.39782 14.5 8.77936 14.342 9.06066 14.0607C9.34196 13.7794 9.5 13.3978 9.5 13C9.5 12.6022 9.34196 12.2206 9.06066 11.9393C8.77936 11.658 8.39782 11.5 8 11.5C7.60218 11.5 7.22064 11.658 6.93934 11.9393C6.65804 12.2206 6.5 12.6022 6.5 13C6.5 13.3978 6.65804 13.7794 6.93934 14.0607C7.22064 14.342 7.60218 14.5 8 14.5Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 14.5C16.3978 14.5 16.7794 14.342 17.0607 14.0607C17.342 13.7794 17.5 13.3978 17.5 13C17.5 12.6022 17.342 12.2206 17.0607 11.9393C16.7794 11.658 16.3978 11.5 16 11.5C15.6022 11.5 15.2206 11.658 14.9393 11.9393C14.658 12.2206 14.5 12.6022 14.5 13C14.5 13.3978 14.658 13.7794 14.9393 14.0607C15.2206 14.342 15.6022 14.5 16 14.5Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 7.5C12.3978 7.5 12.7794 7.34196 13.0607 7.06066C13.342 6.77936 13.5 6.39782 13.5 6C13.5 5.60218 13.342 5.22064 13.0607 4.93934C12.7794 4.65804 12.3978 4.5 12 4.5C11.6022 4.5 11.2206 4.65804 10.9393 4.93934C10.658 5.22064 10.5 5.60218 10.5 6C10.5 6.39782 10.658 6.77936 10.9393 7.06066C11.2206 7.34196 11.6022 7.5 12 7.5Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 17.5V17C6 16.7348 6.14048 16.4804 6.39052 16.2929C6.64057 16.1054 6.97971 16 7.33333 16H8.66667C9.02029 16 9.35943 16.1054 9.60948 16.2929C9.85952 16.4804 10 16.7348 10 17V17.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 17.5V17C14 16.7348 14.1405 16.4804 14.3905 16.2929C14.6406 16.1054 14.9797 16 15.3333 16H16.6667C17.0203 16 17.3594 16.1054 17.6095 16.2929C17.8595 16.4804 18 16.7348 18 17V17.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10.5V10C10 9.73478 10.1405 9.48043 10.3905 9.29289C10.6406 9.10536 10.9797 9 11.3333 9H12.6667C13.0203 9 13.3594 9.10536 13.6095 9.29289C13.8595 9.48043 14 9.73478 14 10V10.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="11" stroke={color} strokeWidth="2" />
      </g>
      <defs>
        <clipPath id="clip0_2394_992">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AdminClubs;
